import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CinewallConfigurator = lazy(() => import('../pages/cinewall-configurator/page'));
const CinewallMetHaard = lazy(() => import('../pages/cinewall-met-haard/page'));
const CinewallMetHaardTechniek = lazy(() => import('../pages/cinewall-met-haard-techniek/page'));
const CinewallPrijs = lazy(() => import('../pages/cinewall-prijs/page'));
const CinewallInspiratie = lazy(() => import('../pages/cinewall-inspiratie/page'));
const CinewallShowroom = lazy(() => import('../pages/cinewall-showroom/page'));
const CinewallOfferte = lazy(() => import('../pages/cinewall-offerte/page'));
const CinewallFAQ = lazy(() => import('../pages/cinewall-faq/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/cinewall-configurator',
    element: <CinewallConfigurator />,
  },
  {
    path: '/cinewall-met-haard',
    element: <CinewallMetHaard />,
  },
  {
    path: '/cinewall-met-haard-techniek',
    element: <CinewallMetHaardTechniek />,
  },
  {
    path: '/cinewall-prijs',
    element: <CinewallPrijs />,
  },
  {
    path: '/cinewall-inspiratie',
    element: <CinewallInspiratie />,
  },
  {
    path: '/cinewall-showroom',
    element: <CinewallShowroom />,
  },
  {
    path: '/cinewall-offerte',
    element: <CinewallOfferte />,
  },
  {
    path: '/offerte',
    element: <Navigate to="/cinewall-offerte" replace />,
  },
  {
    path: '/cinewall-faq',
    element: <CinewallFAQ />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
